<form
  class="flex flex-wrap items-center gap-[1.8%] gap-y-[10px] lg:gap-y-6 mt-12 space-apart"
  [ngClass]="{
    'mobile-two-columns': mobileTwoColumns,
    'mobile-three-columns': mobileThreeColumns
  }"
  [formGroup]="reportsForm"
  autocomplete="off"
>
  <ng-container *ngFor="let input of inputsToShow; trackBy: byInputType">
    <ng-container [ngSwitch]="input">
      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.DATE"
      >
        <mat-label>Date</mat-label>
        <input
          readonly
          matInput
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="date"
          placeholder="Choose a date"
          [formControlName]="reportInputTypes.DATE"
        />
        <mat-datepicker-toggle matSuffix [for]="date"> </mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.START_DATE"
      >
        <mat-label i18n="@@start_date">Start Date</mat-label>
        <input
          formControlName="startDate"
          name="startDate"
          [min]="startDateRange.min"
          [max]="startDateRange.max"
          readonly
          matInput
          [matDatepicker]="startDate"
          (dateChange)="dateListner()"
          placeholder="Start Date"
          i18n-placeholder="@@start_date"
        />
        <mat-datepicker-toggle matSuffix [for]="startDate">
        </mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.END_DATE"
      >
        <mat-label i18n="@@end_date">End Date</mat-label>
        <input
          formControlName="endDate"
          name="endDate"
          readonly
          matInput
          [matDatepicker]="endDate"
          (dateChange)="dateListner()"
          placeholder="End Date"
          i18n-placeholder="@@end_date"
        />
        <mat-datepicker-toggle matSuffix [for]="endDate">
        </mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.REPORT"
      >
        <mat-label i18n="report_day">Report Day</mat-label>
        <mat-select formControlName="report">
          <mat-option *ngFor="let day of reportDays" [value]="day.value">
            {{ day.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <app-area-search-select
        *ngSwitchCase="reportInputTypes.AREA"
        [defaultSelected]="defaultArea ?? savedData?.savedArea"
        [disabled]="!canViewOtherAreas"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.AREA, $event)"
        [control]="getAreaCtrl"
        [type]="type"
      >
      </app-area-search-select>

      <app-branch-search-select
        *ngSwitchCase="reportInputTypes.BRANCH"
        [defaultSelected]="defaultBranch ?? savedData?.savedBranch"
        [disabled]="!canViewOtherAreas && !canViewOtherBranches"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.BRANCH, $event)"
        [control]="getBranchCtrl"
        [areaId]="selectedAreaId"
        [type]="type"
      ></app-branch-search-select>

      <app-client-deposit-search-select
        *ngSwitchCase="reportInputTypes.DEPOSIT_CLIENT"
        [type]="'client'"
        [showDefaultListValue]="showDepositClientDefaultListValue"
        [clientData]="depositClientData"
        [defaultSelected]="savedData?.savedDepositClient"
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.DEPOSIT_CLIENT, $event)
        "
        [branchId]="selectedBranchId"
        [areaId]="selectedAreaId"
        [control]="getDepositClientCtrl"
      ></app-client-deposit-search-select>

      <app-client-search-select
        *ngSwitchCase="reportInputTypes.CLIENT"
        [clientData]="clientData"
        [defaultSelected]="savedData?.savedClient"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.CLIENT, $event)"
        [branchId]="selectedBranchId"
        [areaId]="selectedAreaId"
        [control]="getClientCtrl"
      ></app-client-search-select>

      <app-loan-officer-search-select
        *ngSwitchCase="reportInputTypes.LOAN_OFFICER"
        [showDefaultListValue]="showLoanOfficerDefaultListValue"
        [defaultSelected]="savedData?.savedLoanOfficer"
        [disabled]="!canViewLoanOfficerFilter"
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.LOAN_OFFICER, $event)
        "
        [control]="getLoanOfficerCtrl"
        [branchId]="selectedBranchId"
        [areaId]="selectedAreaId"
        [type]="type"
      ></app-loan-officer-search-select>

      <app-loan-product-search-select
        *ngSwitchCase="reportInputTypes.LOAN_PRODUCT"
        [defaultSelected]="savedData?.savedLoanProduct"
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.LOAN_PRODUCT, $event)
        "
        [control]="getProductCtrl"
        [type]="type"
      ></app-loan-product-search-select>

      <app-deposit-product-search-select
        *ngSwitchCase="reportInputTypes.DEPOSIT_PRODUCT"
        [showDefaultListValue]="showDepositDefaultListValue"
        [defaultSelected]="savedData?.savedDepositProduct"
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.DEPOSIT_PRODUCT, $event)
        "
        [control]="getDepositProductCtrl"
        [type]="type"
      ></app-deposit-product-search-select>

      <app-loan-status-search-select
        *ngSwitchCase="reportInputTypes.LOAN_STATUS"
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.LOAN_STATUS, $event)
        "
        [control]="getStatusCtrl"
      ></app-loan-status-search-select>

      <app-loan-state-search-select
        *ngSwitchCase="reportInputTypes.LOAN_STATE"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.LOAN_STATE, $event)"
        [control]="getLoanStateCtrl"
      ></app-loan-state-search-select>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.LOAN_CLASSIFICATION"
      >
        <mat-label i18n="@@loan_classification">Loan Classification</mat-label>
        <mat-select
          [formControl]="getLoanClassificationCtrl"
          (selectionChange)="
            emitSelectedVal(reportInputTypes.LOAN_CLASSIFICATION, $event.value)
          "
        >
          <mat-option value="PERFORMING">Performing</mat-option>
          <mat-option value="NON_PERFORMING">Non-Performing</mat-option>
          <mat-option value="WATCHLIST">Watchlist</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.LOAN_RISK_CLASSIFICATION"
      >
        <mat-label i18n="@@loan_classification">Loan Classification</mat-label>
        <mat-select
          [formControl]="getLoanRiskClassificationCtrl"
          (selectionChange)="
            emitSelectedVal(
              reportInputTypes.LOAN_RISK_CLASSIFICATION,
              $event.value
            )
          "
        >
          <mat-option value="">All</mat-option>
          <mat-option value="PERFORMING">Performing</mat-option>
          <mat-option value="WATCHLIST">Watchlist</mat-option>
          <mat-option value="SUBSTANDARD">Substandard</mat-option>
          <mat-option value="DOUBTFUL">Doubtful</mat-option>
          <mat-option value="LOST">Lost</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.ACCOUNT_STATE"
      >
        <mat-label i18n="@@customer_type">Customer Type</mat-label>
        <mat-select
          [formControl]="getAccountStateCtrl"
          (selectionChange)="
            emitSelectedVal(reportInputTypes.ACCOUNT_STATE, $event.value)
          "
        >
          <mat-option value="INDIVIDUAL">Individual</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="w-[150px]"
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.CUSTOMER_TYPE"
      >
        <mat-label i18n="@@customer_type">Customer Type</mat-label>
        <mat-select
          [formControl]="getCustomerTypeCtrl"
          (selectionChange)="
            emitSelectedVal(reportInputTypes.CUSTOMER_TYPE, $event.value)
          "
        >
          <mat-option value="INDIVIDUAL">Individual</mat-option>
          <mat-option value="CORPORATE">Corporate</mat-option>
          <mat-option *ngIf="showSmeCustomerType" value="SME">SME</mat-option>
        </mat-select>
      </mat-form-field>
      <app-group-search-select
        *ngSwitchCase="reportInputTypes.GROUP"
        [defaultSelected]="savedData?.savedGroup"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.GROUP, $event)"
        [control]="getGroupCtrl"
        [loanOfficerId]="selectedLoanOfficerId"
      ></app-group-search-select>

      <mat-form-field
        appearance="outline"
        [floatLabel]="mobileFloatLabel"
        *ngSwitchCase="reportInputTypes.LIMIT"
      >
        <mat-label i18n="@@limit">Limit</mat-label>
        <input
          type="text"
          matInput
          appStrictNumbers
          [formControl]="getLimitCtrl"
          (keyup)="emitInputedVal('limit', getLimitCtrl.value)"
          autocomplete="off"
        />
      </mat-form-field>
    </ng-container>
  </ng-container>
  <ng-content></ng-content>
</form>

<div class="mt-6 mb-5" *ngIf="showTableActionFilter">
  <app-table-action-filter
    [showRunButton]="true"
    [disableRunButton]="disableRunButton"
    [title]="title"
    [activeState]="activeState"
    [initialValue]="initialValue"
    [states]="states"
    [actionButtons]="actionButtons"
    [showActionBar2]="showActionBar2"
    [disableActionButtons]="disableActionButtons"
    [showSearchInput]="showSearchInput"
    [showDownloadButton]="showDownloadButton"
    [runText]="runText"
    [runIconPath]="runIconPath"
    [runMenu]="runMenu"
    [showNumOfRowSelected]="showNumOfRowSelected"
    [numOfRowSelected]="numOfRowSelected"
    [totalAmtOfRowSelected]="totalAmtOfRowSelected"
    (searchEmit)="onSearch($event)"
    (runMainMenu)="onRunMenu()"
    (runMenuChange)="onRunMenuChange($event)"
    (stateEmit)="onStateChange($event)"
    (actionEmit)="onActionTrigger($event)"
  ></app-table-action-filter>
</div>

<!-- desktop (>= md 500px): original inline summary bar -->
<div
  *ngIf="showSummaryData && payload?.length > 0"
  class="hidden md:inline-flex bg-summary rounded-[7px] py-[10px] px-[30px] mb-[10px] gap-[50px]"
>
  <ng-container *ngFor="let item of summaryData">
    <label *ngIf="item.type === 'currency'"
      >{{ item.label }}:
      <span class="font-semibold">{{ item.value | currency }}</span></label
    >
    <label *ngIf="item.type === 'number'"
      >{{ item.label }}:
      <span class="font-semibold">{{ item.value }}</span></label
    >
    <label *ngIf="item.type !== 'number' && item.type !== 'currency'"
      >{{ item.label }}:
      <span class="font-semibold">{{ item.value }}</span></label
    >
  </ng-container>
</div>

<!-- mobile (< md 500px): stacked stat pill + report date below (right-aligned) -->
<div
  *ngIf="showSummaryData && payload?.length > 0"
  class="report-summary-mobile md:hidden"
>
  <div class="report-summary-pill">
    <ng-container *ngFor="let item of statItems; let i = index">
      <div class="sm-stat">
        <div class="sm-stat-inner">
          <span class="sm-value">
            <ng-container *ngIf="isSummaryAbbreviated(item)">{{
              summaryAbbrev(item)
            }}</ng-container>
            <ng-container *ngIf="!isSummaryAbbreviated(item)">
              <ng-container *ngIf="item.type === 'currency'">{{
                item.value | currency
              }}</ng-container>
              <ng-container *ngIf="item.type !== 'currency'">{{
                item.value
              }}</ng-container>
            </ng-container>
          </span>
          <span class="sm-label">{{ item.label }}</span>
        </div>
      </div>
      <!-- after every 3rd stat, break to a new row with a divider -->
      <div
        class="sm-divider"
        *ngIf="(i + 1) % 3 === 0 && i + 1 < statItems.length"
      ></div>
    </ng-container>
  </div>

  <ng-container *ngFor="let item of dateItems">
    <p class="sm-date">{{ item.label }}: <strong>{{ item.value }}</strong></p>
  </ng-container>
</div>
